import api from './api';
import type { Societe, CreateSocieteRequest, UpdateSocieteRequest } from '../types';

export const societesService = {
  async list(): Promise<Societe[]> {
    const { data } = await api.get<{ success: boolean; data: { societes: Societe[] } }>('/societes');
    return data.data.societes;
  },

  async getAll(): Promise<Societe[]> {
    return this.list();
  },

  async getById(id: string): Promise<Societe> {
    const { data } = await api.get<{ success: boolean; data: Societe }>(`/societes/${id}`);
    return data.data;
  },

  async create(societeData: CreateSocieteRequest): Promise<Societe> {
    const { data } = await api.post<{ success: boolean; data: { societe: Societe } }>(
      '/societes',
      societeData
    );
    return data.data.societe;
  },

  async update(id: string, societeData: UpdateSocieteRequest): Promise<Societe> {
    const { data } = await api.put<{ success: boolean; data: Societe }>(
      `/societes/${id}`,
      societeData
    );
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/societes/${id}`);
  },

  // Notes pour un AO
  async getNotes(societeId: string, aoId: string): Promise<any> {
    const { data } = await api.get<{ success: boolean; data: any }>(
      `/societes/${societeId}/notes/${aoId}`
    );
    return data.data;
  },

  async updateNotes(societeId: string, aoId: string, notes: any): Promise<void> {
    await api.put(`/societes/${societeId}/notes/${aoId}`, notes);
  },
};

export default societesService;
